import { render, staticRenderFns } from "./NvBookGrid.vue?vue&type=template&id=af1d913e&scoped=true&"
import script from "./NvBookGrid.vue?vue&type=script&lang=js&"
export * from "./NvBookGrid.vue?vue&type=script&lang=js&"
import style0 from "./NvBookGrid.vue?vue&type=style&index=0&id=af1d913e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d913e",
  null
  
)

export default component.exports